module.exports = __webpack_public_path__ + "media/stylesheets/images/focus-418ae341867ef563a4d21eb6eaeeb20a.svg";